/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/no-children-prop */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useMemo, SetStateAction, Dispatch, useEffect } from 'react'
import { GoogleMap, Marker } from '@react-google-maps/api'
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Input,
  Text,
  ButtonGroup,
  InputGroup,
  InputLeftElement,
  Stack
} from '@chakra-ui/react'
import { IoMdLocate, IoMdSearch } from 'react-icons/io'
import { FaTimes } from 'react-icons/fa'
import './index.scss'
import { HiLocationMarker } from 'react-icons/hi'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import { ReactI18NextChild } from 'react-i18next'

interface MapFormState {
  setClickedLatLng: Dispatch<SetStateAction<{ lat: number; lng: number; placeId: string; name: string } | undefined>>
  executeScroll: any
}

type LatLngLiteral = google.maps.LatLngLiteral
type MapOptions = google.maps.MapOptions
// type MapMouseEvent = google.maps.MapMouseEvent

const containerStyle = {
  width: '100%',
  height: '100%'
}

export default function Map({ setClickedLatLng, executeScroll }: MapFormState) {
  const [center, setCenter] = useState<LatLngLiteral>({ lat: 13.7, lng: 100.4 })
  const [clickedPos, setClickedPos] = useState<LatLngLiteral>({} as google.maps.LatLngLiteral)
  const [markerMap, setMarkerMap] = useState<any>(/** @type google.maps.Map */ null)
  const [nearbyLocation, setNearbyLocation] = useState<any[]>()
  const [address, setAddress] = useState('')
  const options = useMemo<MapOptions>(
    () => ({
      // zoomControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'landscape.natural',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#e0efef'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'on'
            },
            {
              hue: '#1900ff'
            },
            {
              color: '#c0e8e8'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              lightness: 100
            },
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on'
            },
            {
              lightness: 700
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              color: '#7dcdcd'
            }
          ]
        }
      ]
    }),
    []
  )

  const onMapLoad = (map: object) => {
    setMarkerMap(map as SetStateAction<null>)

    navigator?.geolocation.getCurrentPosition(({ coords: { latitude: lat, longitude: lng } }) => {
      const pos = { lat, lng }
      // @ts-expect-error
      const service = new google.maps.places.PlacesService(map)
      const request: any = {
        location: pos,
        radius: '300',
        type: ['restaurant']
      }
      service.nearbySearch(request, (results, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          setNearbyLocation(results as SetStateAction<any[] | undefined>)
        }
      })
    })
  }

  const onMapClick = (map: any) => {
    console.log('🚀 ~ file: map.tsx ~ line 150 ~ onMapClick ~ e', map)
    setClickedPos({ lat: map.latLng!.lat(), lng: map.latLng!.lng() })

    const service = new google.maps.places.PlacesService(markerMap)

    if (map.placeId) {
      const request = {
        placeId: map.placeId,
        fields: ['name', 'formatted_address', 'place_id', 'geometry']
      }

      service.getDetails(request, (place, status) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          place != null &&
          place.geometry != null &&
          place.geometry.location != null
        ) {
          setClickedLatLng({ ...map.latLng?.toJSON(), name: `${place.name} ${place.formatted_address}` })
        }
      })
    } else {
      setClickedLatLng({ ...map.latLng?.toJSON(), name: `${map.latLng!.lat()},${map.latLng!.lng()}` })
    }
  }

  const getCurrentLocation = () => {
    navigator?.geolocation.getCurrentPosition(({ coords: { latitude: lat, longitude: lng } }) => {
      const pos = { lat, lng }
      setCenter(pos)
    })
  }

  const onCurrentLocation = () => {
    getCurrentLocation()
    markerMap.panTo(center)
    markerMap.setZoom(16)
  }

  const onClickNearbyLocation = (location: { lat: any; lng: any }, placeId: string, name: string, vicinity: string) => {
    setClickedPos({ lat: location?.lat(), lng: location?.lng() })
    setClickedLatLng({ lat: location?.lat(), lng: location?.lng(), placeId, name: `${name} ${vicinity}` })
    markerMap.panTo({ lat: location?.lat(), lng: location?.lng() })
    markerMap.setZoom(16)
    executeScroll()
  }

  const handleChange = (address: any) => {
    setAddress(address)
  }

  const handleSelect = (address: any) => {
    geocodeByAddress(address)
      .then(async (results: any[]) => await getLatLng(results[0]))
      .then((latLng: any) => {
        setClickedPos(latLng)
        setClickedLatLng({ ...latLng, name: address })
        setAddress(address)
        markerMap.panTo(latLng)
        markerMap.setZoom(16)
      })
      .catch((error: any) => console.error('Error', error))
  }

  useEffect(() => {
    getCurrentLocation()
  }, [])

  return (
    <Flex position="relative" flexDirection="column" alignItems="center" h="100%" w="100%">
      <Box w="100%" h="60vh">
        <GoogleMap
          zoom={16}
          center={center}
          options={options}
          onLoad={map => onMapLoad(map)}
          mapContainerStyle={containerStyle}
          onClick={map => onMapClick(map)}
        >
          {clickedPos.lat ? <Marker position={clickedPos} /> : null}
          {center && (
            <Marker
              position={center}
              onClick={onMapClick}
              icon={{
                url: 'https://upload.convolab.ai/viriyah-dev%2F65fadb4e-5120-43c0-8f32-6ab5c42311a3.png',
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(15, 15),
                scaledSize: new window.google.maps.Size(25, 25)
              }}
            />
          )}
        </GoogleMap>
      </Box>
      <Box
        bgColor="#FFFFFF"
        borderTopRightRadius="8px"
        borderTopLeftRadius="8px"
        position="inherit"
        left={0}
        bottom={0}
        display="flex"
        className="places-style"
      >
        <PlacesAutocomplete value={address} onChange={handleChange} onSelect={handleSelect}>
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <Box id="searchbox">
              <HStack
                minWidth="max-content"
                spacing={2}
                justifyContent="space-between"
                alignItems="flex-start"
                mb="5%"
                p="16px 16px 0px 16px"
              >
                <InputGroup className="input-autocomplete-style">
                  <InputLeftElement pointerEvents="none" children={<IoMdSearch className="icon-input-left" />} />
                  <Input
                    height="40px"
                    fontSize="18px"
                    fontWeight="400"
                    borderRadius="8px"
                    border="1px solid #E5E5E5"
                    {...getInputProps({
                      placeholder: 'Search',
                      className: 'location-search-input'
                    })}
                  />
                </InputGroup>
                <ButtonGroup>
                  {address !== null && address?.length > 0 && (
                    <IconButton
                      aria-label="center back"
                      fontSize="24px"
                      width="40px"
                      height="40px"
                      background="#fff"
                      color="#666666"
                      icon={<FaTimes />}
                      onClick={() => setAddress('')}
                    />
                  )}

                  <IconButton
                    aria-label="center back"
                    fontSize="24px"
                    width="40px"
                    height="40px"
                    background="#fff"
                    color="#666666"
                    icon={<IoMdLocate />}
                    onClick={onCurrentLocation}
                  />
                </ButtonGroup>
              </HStack>

              <div className="autocomplete-dropdown-container">
                {loading && <Text fontSize="16px">Loading...</Text>}
                {address !== null && address?.length > 0
                  ? suggestions.map(
                      (suggestion: {
                        formattedSuggestion: any
                        active: any
                        description:
                          | boolean
                          | React.ReactChild
                          | React.ReactFragment
                          | React.ReactPortal
                          | Iterable<ReactI18NextChild>
                          | null
                          | undefined
                      }) => {
                        const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                          : { backgroundColor: '#ffffff', cursor: 'pointer' }
                        return (
                          <Box
                            /** @ts-expect-error */
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style
                            })}
                            _active={{
                              background: '#CBD5E0',
                              paddingBottom: '1%',
                              paddingTop: '1%',
                              paddingLeft: '2%',
                              paddingRight: '2%'
                            }}
                          >
                            <Stack spacing={8} direction="row" mb="3%">
                              <Box fontSize="20px" display="flex" alignItems="center">
                                <HiLocationMarker />
                              </Box>
                              <Box>
                                <Text fontSize="16px" fontWeight="500">
                                  {suggestion.formattedSuggestion.mainText}
                                </Text>
                                <Text fontSize="14px" color="#757575" fontWeight="400" maxWidth="300px" noOfLines={1}>
                                  {suggestion.formattedSuggestion.secondaryText}
                                </Text>
                              </Box>
                            </Stack>
                          </Box>
                        )
                      }
                    )
                  : (nearbyLocation ?? []).map(({ place_id: placeId, name, vicinity, geometry }) => (
                      <Box
                        key={placeId}
                        onClick={() => onClickNearbyLocation(geometry.location, placeId, name, vicinity)}
                        _active={{
                          background: '#CBD5E0',
                          paddingBottom: '1%',
                          paddingTop: '1%',
                          paddingLeft: '2%',
                          paddingRight: '2%'
                        }}
                      >
                        <Stack spacing={8} direction="row" mb="3%">
                          <Box fontSize="20px" display="flex" alignItems="center">
                            <HiLocationMarker />
                          </Box>
                          <Box>
                            <Text fontSize="16px" fontWeight="500">
                              {name}
                            </Text>
                            <Text fontSize="14px" color="#757575" fontWeight="400" maxWidth="300px" noOfLines={1}>
                              {vicinity}
                            </Text>
                          </Box>
                        </Stack>
                      </Box>
                    ))}
              </div>
            </Box>
          )}
        </PlacesAutocomplete>
      </Box>
    </Flex>
  )
}
